function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHeaderShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 0A20 20 0 0 0 0 20a20 20 0 0 0 20 20 20 20 0 0 0 20-20A20 20 0 0 0 20 0zm0 7c3.327 0 6.653 1.27 9.191 3.809 5.077 5.076 5.077 13.305 0 18.382-5.076 5.077-13.305 5.077-18.382 0-5.077-5.076-5.077-13.305 0-18.382A12.957 12.957 0 0 1 20 7zm0 1.857a11.11 11.11 0 0 0-7.88 3.262c-3.814 3.814-4.285 9.705-1.415 14.031.205.31.006.006.006.006.359.498 1.015.546 1.451.11l7.713-7.711c.289-.29.191-.526-.22-.524l-2.86.006c-1.483.002-1.48-2.224.004-2.226l6.342-.079a1.08 1.08 0 0 1 1.103 1.098l-.055 6.371c-.002 1.483-2.228 1.487-2.226.004l.006-2.86c.002-.41-.234-.51-.524-.22l-7.71 7.713c-.435.434-.39 1.084.105 1.45 0 0-.292-.193.023.015 4.326 2.86 10.207 2.385 14.016-1.424 4.35-4.351 4.35-11.407 0-15.758A11.107 11.107 0 0 0 20 8.857z",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeaderShare);
export default __webpack_public_path__ + "static/media/ic_header_share.08d81f9f3a453a3e847f22363d51ed84.svg";
export { ForwardRef as ReactComponent };